__turbopack_context__.v({
  "faqElement": "FAQSection-module__br3V6W__faqElement",
  "h2": "FAQSection-module__br3V6W__h2",
  "root": "FAQSection-module__br3V6W__root",
});
